import ServerProfilePanel from './ServerProfilePanel';
import surface from '../ProjectSurface.module.css';

/** Deliberately narrow: Server Settings owns profile configuration only. */
export default function ServerSettingsPage() {
  return (
    <main className={surface.pageRoot} data-page="server-settings">
      <ServerProfilePanel />
    </main>
  );
}
